<template>
  <div :class="{ 'grid-x': isPriceReviewsCombined }">
    <Price
      :price="selectedPrice"
      :name="'price'"
      v-bind="$attrs"
      :class="{ 'cell small-9': isPriceReviewsCombined }"
      :additional-fee
      :is-pricing-simplification="priceSimplificationEnabled"
      :is-klarna-spacing-enabled="isPDPEnhancementDEnabled"
      :surcharge-shipping-message-enabled="surchargeShippingMessageEnabled"
      :is-percentage-style-update="priceSimplificationEnabled"
      :is-product-perks-enabled="isProductPerksEnabled"
      :is-final-price-promo-copy-update-enabled="isFinalPricePromoCopyUpdateEnabled"
      :is-pricing-specials-badge-enabled="experimentFlags.isPricingSpecialsBadgeEnabled"
      :is-bmsm-enabled="experimentFlags.isBMSMEnabled"
      :is-countdown-enabled="experimentFlags.isCountdownEnabled"
      :is-badge-sale-red="experimentFlags.isBadgeSaleRed"
      :mocked-price-valid-date="mockPriceDateValue"
      @open-details-modal="firePromoTag"
    />

    <ReviewRating v-if="isPriceReviewsCombined" class="cell small-3 reviewlet" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { Price } from '@nuxt-common/media-card-large/app/modules/price/components';
import ReviewRating from '~/modules/reviews/components/ReviewRating.vue';

import { useProductPrice } from '~/modules/price/composables/useProductPrice';
import useExperiments from '~/stores/useExperimentsStore';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import { useDeviceType } from '~/composables/utils/useDeviceType';
import { useProductType } from '~/composables/useProductType';
import useReviewsStatistics from '~/modules/reviews/composables/useReviewsStatistics';
import tagSecondaryPromo from '~/features/analytics/secondaryPromo';
import { useRoute } from 'vue-router';

defineOptions({ inheritAttrs: false });

const props = defineProps({
  id: {
    type: [String, Number],
    required: true,
  },
  product: {
    type: Object,
    required: true,
  },
  currentZipCodeAvailability: {
    type: Object,
    required: false,
    default: null,
  },
  additionalFee: {
    type: Object,
    required: false,
    default: null,
  },
});

const selectedPrice = useProductPrice();
const { killswitches } = useKillswitches();
const { isMaster, isShopTheSet } = useProductType();
const { isMobile } = useDeviceType();

const { isPDPEnhancementDEnabled, priceSimplificationEnabled, surchargeShippingMessageEnabled, isFinalPricePromoCopyUpdateEnabled } = killswitches;
const { isProductPerksEnabled, isReviewletOptimizationEnabled } = useFeatureEligibility();
const { totalCount } = useReviewsStatistics();
const { experimentFlags } = useExperiments();
const route = useRoute();

const mockPriceDateValue = computed(() => {
  if (experimentFlags.isCountdownEnabled) {
    return route.query.mockPriceDateValue ?? null;
  }
  return null;
});

const isPriceReviewsCombined = computed(() => isReviewletOptimizationEnabled && (!isMaster || isShopTheSet) && !!totalCount.value && isMobile.value);

const firePromoTag = () => {
  tagSecondaryPromo(props.id, selectedPrice.value?.offers?.lists?.activeOffers?.length || 0);
};
</script>

<style scoped lang="scss">
.reviewlet {
  justify-items: end;
}
</style>

<style lang="scss">
.klarna-container {
  ::part(osm-container) {
    font-family:
      Macys Sans,
      Helvetica Neue,
      Helvetica,
      Arial,
      sans-serif !important;
  }
}
</style>
